<template>
    <div class="header">
        <div class="logo">
            Open Movies
        </div>
    </div>
</template>

<script>
export default {
    name: "Header",
    
}
</script>

<style scoped>
    .logo {
        font-size: 24px;
        margin-top: 10px;
        margin-left: 10px;
        color: #777575;
        font-weight: lighter;
    }
</style>